<template>
  <v-dialog v-model="dialog" max-width="800px" persistent>
    <v-btn
      icon
      slot="activator"
    >
      <v-icon color="primary">edit</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Veranstaltung bearbeiten</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex sm12>
              <v-text-field label="Logo" @click='pickFile' v-model='imageName' prepend-icon='attach_file'>
              </v-text-field>
              <v-img
                v-if="imageUrl"
                :src="imageUrl"
                height="150"
                contain></v-img>
              <input type="file" @change="showThumbnail" ref="pictureInput" style="display: none" accept="image/*"/>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Titel"
                required
                v-model="localEvent.title"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                label="Beschreibung"
                required
                v-model="localEvent.description"
                :disabled="loading"></v-textarea>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Maximale Breite in Pixel (leer = maximum)"
                type="number"
                required
                v-model="localEvent.maxWidth"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="URL (leer = Bild öffnet sich beim klick)"
                required
                v-model="localEvent.url"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="40"
                :return-value.sync="date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="this.localEvent.date"
                  label="Veranstaltungsdatum"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="date"
                  scrollable
                  @input="$refs.menu.save(date)"
                  first-day-of-week="1"
                  locale="de-DE"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6>
              <v-menu
                ref="menuToDate"
                :close-on-content-click="false"
                v-model="menuToDate"
                :nudge-right="40"
                :return-value.sync="toDate"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="this.localEvent.toDate"
                  label="Bis"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="toDate"
                  scrollable
                  @input="$refs.menuToDate.save(toDate)"
                  first-day-of-week="1"
                  locale="de-DE"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12>
              <v-checkbox
                v-model="localEvent.hideItem"
                label="Nicht in der Aktivitätenübersicht anzeigen"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 v-if="localEvent.id">
              <dropzone ref="dropzone" :files="localEvent.galleryImages" @removeFile="removeFile" />
            </v-flex>
          </v-layout>
        </v-container>
        <small>*Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="update()" :loading="loading">Speichern</v-btn>
        <v-btn color="error" @click.native="dialog = false">Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
// import S3Dropzone from '@/modules/ui/_components/s3Dropzone';
import awsExport from '@/aws-exports';
import Dropzone from '@/modules/files/_components/Dropzone';

export default {
  name: 'DlgEventEdit',
  components: {
    Dropzone,
    // S3Dropzone,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      localEvent: {},
      date: null,
      toDate: null,
      menu: false,
      menuToDate: false,
      bucketName: awsExport.aws_user_files_s3_bucket,
      s3Region: awsExport.aws_user_files_s3_bucket_region,
      imageUrl: null,
      imageName: null,
    };
  },
  props: ['event'],
  methods: {
    ...mapActions({
      eventUpdate: 'event/update',
      eventRead: 'event/read',
    }),
    update() {
      const files = this.$refs.dropzone.getFileList();
      this.loading = true;
      this.eventUpdate({ event: this.localEvent, image: this.$refs.pictureInput.files[0], files })
        .then((res) => {
          this.loading = false;
          if (res) {
            this.eventRead();
            this.localEvent = {};
            this.$refs.dropzone.clear();
            this.dialog = false;
          }
        });
    },
    onChange() {
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split('.');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    pickFile() {
      this.$refs.pictureInput.click();
    },
    showThumbnail() {
      this.imageUrl = URL.createObjectURL(this.$refs.pictureInput.files[0]);
      this.imageName = this.$refs.pictureInput.files[0].name;
    },
    removeFile(i) {
      console.log(i);
      this.localEvent.galleryImages.splice(i, 1);
    },
  },
  watch: {
    dialog() {
      this.localEvent = JSON.parse(JSON.stringify(this.event));
      this.date = this.parseDate(this.localEvent.date);
      this.toDate = this.parseDate(this.localEvent.toDate);
      this.imageUrl = this.localEvent.imageUrl;
    },
    date(val) {
      this.localEvent.date = this.formatDate(val);
    },
    toDate(val) {
      this.localEvent.toDate = this.formatDate(val);
    },
  },
};
</script>

<style scoped>

</style>
